// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__qYkJv","col":"styles_col__3wpOh"};